<template>
  <div class="search-wrapper">
    <div class="container">
      <!-- Logo -->
      <!-- <div class="logo-container">
        <a href="/" class="image">
          <img src="../assets/galaxy_logo_white.svg" alt="CVtèque 2.0" />
        </a>
      </div> -->

      <div class="logo-container":class="{ 'with-subtext': userType === 'agent', 'no-subtext': userType !== 'agent' }"
      >
        <div class="logo-wrapper">
          <a href="/" class="image">
            <img src="../assets/galaxy_logo_white.svg" alt="CVtèque 2.0" class="main-logo" />
          </a>
      
          <!-- Subtext / team logo below -->
          <div class="subtext-wrapper" v-if="userType === 'agent'">
            <img src="../assets/team.png" alt="Teams" class="teams-logo" />
            <span class="teams-label"></span>
          </div>
        </div>
      </div>
      <!-- Main search interface -->
      <div class="search-interface">
        <!-- Search bar -->
         <!--we removed this @input="debouncedSearch" -->
        <div class="search-bar" :class="{ 'expanded': showFilters }">
          <input
            ref="searchInput"
            v-model="searchQuery"
            
            
            @focus="expandSearch"
            @keyup.enter="handleSearch()"
            type="text"
            class="search-input"
            :placeholder="showFilters ? 'Search resumes...' : 'How can I help you find the right candidate?'"
          />
          
          <div class="search-actions">
                  <!-- Snarky AI Warning Toast -->
<transition name="fade-slide">
  <div v-if="showAIWarning" class="ai-warning-toast">
    <i class="fas fa-lightbulb"></i>
    <span>{{ aiWarningMessage }}</span>
  </div>
</transition>
              <!-- NL Search Toggle Button -->
          <button
          @click="toggleNLSearch"
          class="nl-toggle-button"
          :class="{ active: useNLSearch }"
          :disabled="isLoading"
          title="Natural Language Search"
        >
          <i class="fas fa-magic"></i>
        </button>
            <button
              v-if="searchQuery"
              @click="clearSearch"
              class="clear-button"
              :disabled="isLoading"
            >
              <i class="fas fa-times"></i>
            </button>
            
            <button
              @click="handleSearch"
              class="search-button"
              :disabled="isLoading"
            >
              <i v-if="!isLoading" class="fas fa-search"></i>
              <i v-else class="fas fa-spinner fa-spin"></i>
            </button>
          </div>
        </div>

        <!-- NL Search Stream -->         
        <NLSearchStream 
        :query="nlQuery"
        :isActive="nlSearchActive"
        @close="handleNLSearchClose"
        @view-results="handleNLSearchViewResults"
        @error="(msg) => { errorMessage = msg; errorExists = true; }"
      />


        <transition name="fade">
          <div v-if="useBooleanMode" class="boolean-badge">
            <i class="fas fa-code"></i>
            Boolean
          </div>
        </transition>
        <!-- Filter pills and filters section -->
        <transition name="slide-fade">
          <div v-if="showFilters" class="filters-section">
            <!-- Quick filter pills -->
            <div class="quick-filters">
              <button
                v-for="filter in quickFilterOptions"
                :key="filter.key"
                @click="toggleQuickFilter(filter.key)"
                class="filter-pill"
                :class="{ active: activeFilters.has(filter.key) }"
              >
                <i :class="filter.icon"></i>
                {{ filter.label }}
              </button>
              
              <button
                v-if="activeFilters.size > 0"
                @click="resetAllFilters"
                class="filter-pill reset"
              >
                <i class="fas fa-undo"></i>
                Reset Filters
              </button>
            </div>

            <!-- Detailed filters -->
            <div class="detailed-filters">
              <!-- Experience Range -->
              <div v-if="activeFilters.has('experience')" class="filter-group">
                <label>Years of Experience: {{ getExperienceRangeLabel() }}</label>
                <Slider
                  v-model="experienceRange"
                  range
                  :min="experienceRangeMin"
                  :max="experienceRangeMax"
                  :step="6"
                  @slideend="onExperienceRangeChange"
                  class="experience-slider"
                />
                
                <!-- Experience presets -->
                <div class="experience-presets">
                  <button 
                    class="preset-btn"
                    @click="setExperiencePreset([0, 60])"
                    :class="{ active: experienceRange[0] === 0 && experienceRange[1] === 60 }"
                  >
                    Any
                  </button>
                  <button 
                    class="preset-btn"
                    @click="setExperiencePreset([6, 24])"
                    :class="{ active: experienceRange[0] === 6 && experienceRange[1] === 24 }"
                  >
                    6m-2y
                  </button>
                  <button 
                    class="preset-btn"
                    @click="setExperiencePreset([24, 60])"
                    :class="{ active: experienceRange[0] === 24 && experienceRange[1] === 60 }"
                  >
                    2y-5y
                  </button>
                  <button 
                    class="preset-btn"
                    @click="setExperiencePreset([36, 60])"
                    :class="{ active: experienceRange[0] === 36 && experienceRange[1] === 60 }"
                  >
                    3y-5y
                  </button>

                  <button 
                    class="preset-btn"
                    @click="setExperiencePreset([60, 120])"
                    :class="{ active: experienceRange[0] === 60 && experienceRange[1] === 120 }"
                  >
                    5y-10y
                  </button>
                  <button 
                    class="preset-btn"
                    @click="setExperiencePreset([120, 180])"
                    :class="{ active: experienceRange[0] === 120 && experienceRange[1] === 180 }"
                  >
                    10y-15y
                  </button>

                  <button 
                    class="preset-btn"
                    @click="setExperiencePreset([180, 900])"
                    :class="{ active: experienceRange[0] === 180 && experienceRange[1] === 900 }"
                  >
                    15y+
                  </button>
                  
                </div>
              </div>

              <!-- Skills Filter -->
              <div v-if="activeFilters.has('skills')" class="filter-group">
                <label>Skills</label>
                <MultiSelect
                :key="skillsDropdownKey"
                v-model="selectedSkills"
                  :options="skillOptions"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Select skills..."
                  :filter="true"
                  :filterValue="skillFilterValue"
                  :showToggleAll="false"
                  class="skills-select"
                  @filter="onSkillFilter"
                  @update:modelValue="onSkillSelectionChange"
                  :loading="isLoadingSkills"
                  :selectedItemsLabel="''"
                  display="chip"
                />
                <!-- <MultiSelect

                  v-model="selectedSkills"
                

                  :options="skillOptions"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Select skills..."
                  :filter="true"
                  :filterValue="skillFilterValue"
                  :showToggleAll="false"
                  class="skills-select"
                  @filter="onSkillFilter"
                  @update:modelValue="onSkillSelectionChange"
                  :loading="isLoadingSkills"
                  :selectedItemsLabel="''"
                  display="chip"
 
                />
                 -->
                <!-- Selected skills chips -->
                <div v-if="selectedSkills.length > 0" class="selected-skills">
                  <div
                    v-for="skill in selectedSkills"
                    :key="skill"
                    class="skill-chip"
                  >
                    {{ typeof skill === 'object' ? skill.label : skill }}
                    <button
                      class="chip-remove"
                      @click="removeSkill(skill)"
                    >
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                </div>
              </div>

              <!-- Location Filter -->
              <div v-if="activeFilters.has('location')" class="filter-group">
                <label>Location</label>
                <MultiSelect
                  v-model="selectedLocations"
                  :selectedItemsLabel="''"
                  :options="locationOptions"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Select locations..."
                  :filter="true"
                  :showToggleAll="false"
                  class="location-select"
                  @filter="searchLocations"
                  @update:modelValue="onLocationSelectionChange"
                  :loading="isLoadingLocations"
                />
                
                <!-- Selected locations chips -->
                <div v-if="selectedLocations.length > 0" class="selected-skills">
                  <div
                    v-for="location in selectedLocations"
                    :key="location"
                    class="skill-chip"
                  >
                    {{ typeof location === 'object' ? location.label : location }}
                    <button
                      class="chip-remove"
                      @click="removeLocation(location)"
                    >
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                </div>
              </div>

              <!-- AI Semantic Search -->
              <div v-if="activeFilters.has('semantic')" class="filter-group">
                <label>AI-Powered Semantic Search</label>
                <div class="ai-options">
                  <div class="checkbox-label">
                    <input
                      type="checkbox"
                      v-model="useRAGSearch"
                      @change="toggleRAGFields"
                    />
                    <span>Use AI Analysis & Recommendations</span>
                  </div>
                  
                  <div v-if="useRAGSearch" class="rag-fields">
                    <Textarea
                      v-model="query"
                      placeholder="Who are you looking for? (e.g. 'Senior ML engineer with NLP experience')"
                      class="semantic-input"
                      rows="2"
                    />
                    <Textarea
                      v-model="jobDescription"
                      placeholder="Role overview, key responsibilities, must-have skills, seniority level..."
                      class="semantic-input"
                      rows="1"
                    />
                    <Textarea
                      v-model="additionalContext"
                      placeholder="Company culture, team structure, sourcing preferences, domain focus..."
                      class="semantic-input"
                      rows="4"
                    />
                  </div>
                  
                  <!-- Regular semantic search -->
                  <div v-if="!useRAGSearch" class="semantic-search-basic">
                    <Textarea
                      v-model="semanticSearchQuery"
                      placeholder="Example: 'Machine learning engineer who built recommendation systems'"
                      class="semantic-input"
                      rows="2"
                    />
                    
                    <!-- Vector fields selection -->
                    <div class="vector-fields-container">
                      <label>Search In:</label>
                      <div class="vector-field-checkboxes">
                        <div 
                          v-for="field in vectorFieldOptions" 
                          :key="field.value"
                          class="vector-field-checkbox"
                        >
                          <Checkbox
                            :inputId="'vector_' + field.value"
                            v-model="selectedVectorFields"
                            :value="field.value"
                            :binary="false"
                          />
                          <label :for="'vector_' + field.value" class="checkbox-label">{{ field.label }}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div class="semantic-actions">
                    <button
                      @click="useRAGSearch ? performRAGSearch() : handleSemanticSearch()"
                      class="semantic-button"
                      :disabled="isLoading || (!query.trim() && !semanticSearchQuery.trim())"
                    >
                      <i class="fas fa-brain"></i>
                      {{ useRAGSearch ? 'Analyze & Recommend' : 'Semantic Search' }}
                    </button>
                    
                    <button
                      @click="clearSemanticFields"
                      class="semantic-reset"
                    >
                      <i class="fas fa-eraser"></i>
                      Clear
                    </button>
                  </div>
                </div>
              </div>
              <!-- Boolean Search Syntax Help -->
<div v-if="activeFilters.has('boolean')" class="filter-group boolean-help-section">
  <div class="boolean-syntax-card">
    <div class="syntax-header">
      <i class="fas fa-info-circle"></i>
      <span>Boolean Search Syntax</span>
    </div>
    
    <div class="syntax-examples">
      <div class="syntax-item">
        <code>"exact phrase"</code>
        <span>Match exact phrase</span>
      </div>
      
      <div class="syntax-item">
        <code>+required</code>
        <span>Must include this term</span>
      </div>
      
      <div class="syntax-item">
        <code>-excluded</code>
        <span>Must NOT include this</span>
      </div>
      
     
      
      <div class="syntax-item">
        <code>+python +"machine learning"</code>
        <span>Must have both (AND)</span>
        <span> When using multiple terms with AND, only the first term has priority in ranking results.</span>
      </div>
    </div>
    
    <div class="syntax-note">
      <i class="fas fa-lightbulb"></i>
      <small>Boolean mode uses strict matching. For fuzzy results, disable boolean mode.</small>
    </div>
  </div>
</div>


              <!-- Contact filters -->
              <div v-if="activeFilters.has('contact')" class="filter-group">
                <label>Contact Information</label>
                <div class="contact-filters">
                  <div class="contact-input-group">
                    <input
                      v-model="candidateId"
                      @keyup.enter="handleSearch"
                      type="text"
                      class="contact-input"
                      placeholder="Candidate ID..."
                    />
                    <i v-if="candidateId" @click="candidateId = ''; handleSearch()" class="fas fa-times clear-contact"></i>
                  </div>
                  
                  <div class="contact-input-group">
                    <input
                      v-model="candidateName"
                      @keyup.enter="handleSearch"
                      type="text"
                      class="contact-input"
                      placeholder="Full name..."
                    />
                    <i v-if="candidateName" @click="candidateName = ''; handleSearch()" class="fas fa-times clear-contact"></i>
                  </div>
                  
                  <div class="contact-input-group">
                    <input
                      v-model="candidateEmail"
                      @keyup.enter="handleSearch"
                      type="email"
                      class="contact-input"
                      placeholder="Email address..."
                    />
                    <i v-if="candidateEmail" @click="candidateEmail = ''; handleSearch()" class="fas fa-times clear-contact"></i>
                  </div>
                  
                  <div class="contact-input-group">
                    <input
                      v-model="candidatePhone"
                      @keyup.enter="handleSearch"
                      type="tel"
                      class="contact-input"
                      placeholder="Phone number..."
                    />
                    <i v-if="candidatePhone" @click="candidatePhone = ''; handleSearch()" class="fas fa-times clear-contact"></i>
                  </div>
                </div>
                
                <!-- Contact chips stay the same -->
                <div v-if="getContactChips().length > 0" class="selected-contacts">
                  <div
                    v-for="chip in getContactChips()"
                    :key="chip.key"
                    class="contact-chip"
                  >
                    {{ chip.label }}: {{ chip.value }}
                    <button @click="clearContactField(chip.key)" class="chip-remove">
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                </div>
              </div>

          <!-- Sort Filter Section -->
            <div v-if="activeFilters.has('sort')" class="filter-group">
              <div class="filter-header">
                <i class="fas fa-sort"></i>
                <h4>Sort By</h4>
              </div>
              
              <div class="filter-content">
                <div class="sort-options">
                  <button
                    v-for="option in sortOptions"
                    :key="option.value"
                    @click="selectedSort = option.value; handleSearch()"
                    class="sort-option-btn"
                    :class="{ active: selectedSort === option.value }"
                  >
                    <i :class="option.icon"></i>
                    {{ option.label }}
                  </button>
                </div>
              </div>
            </div>
<!-- View Filter -->
<!-- <div v-if="activeFilters.has('views')" class="filter-group">
  <div class="filter-header">
    <i class="fas fa-eye"></i>
    <h4>Profile Views</h4>
  </div>
  <div class="filter-content">
    <div class="sort-options">
      <button
        v-for="option in viewFilterOptions"
        :key="option.value"
        @click="selectedViewFilter = option.value; handleSearch()"
        class="sort-option-btn"
        :class="{ active: selectedViewFilter === option.value }"
      >
        <i :class="option.icon"></i>
        {{ option.label }}
      </button>
    </div>
  </div>
</div> -->

            </div>
          </div>
        </transition>
           <!-- View filter toggle (compact, always visible when logged in as agent) -->
   <div v-if="userRole === 'agent'" class="view-filter-bar">
    <button
      v-for="option in viewFilterOptions"
      :key="option.value"
      @click="selectedViewFilter = option.value; handleSearch()"
      class="view-filter-btn"
      :class="{ active: selectedViewFilter === option.value }"
    >
      <i :class="option.icon"></i>
      {{ option.label }}
    </button>
    <button
            v-if="false && totalResults > 0"
            @click="searchWithinResults = !searchWithinResults"
            class="view-filter-btn"
            :class="{ active: searchWithinResults }"
            :title="searchWithinResults ? 'Searching within current results' : 'Search full database'"
          >
            <i :class="searchWithinResults ? 'fas fa-filter' : 'fas fa-database'"></i>
            {{ searchWithinResults ? 'Within Set' : 'Full DB' }}
          </button>
          <div v-if="hasSearched && !isLoading && totalResults > 0 && userRole === 'agent'" class="add-all-bar">
            <button @click="toggleAddAllBoard" class="add-all-btn">
              <i class="fas fa-columns"></i> Ajouter au board (top {{ Math.min(totalResults, 50) }})
            </button>
            <div v-if="showAddAllBoard" class="add-all-picker" @click.stop>
              <div v-if="!addAllBoards.length" class="aap-loading"><i class="fas fa-spinner fa-spin"></i></div>
              <button v-for="b in addAllBoards" :key="b.id" class="aap-option" @click="addAllToBoard(b.id)">
                <span class="aap-dot" :style="{ background: b.color || '#93c5fd' }"></span>
                {{ b.label }}
              </button>
            </div>
          </div>
  </div>

      </div>
<!-- Hot List Active Banner -->
<!-- <div v-if="searchWithinHotList && activeHotListName" class="hot-list-banner">
  <div class="banner-content">
    <i class="fas fa-fire"></i>
    <span>Searching within: <strong>{{ activeHotListName }}</strong> ({{ hotListCandidateIds.length }} candidates)</span>
    <button @click="clearHotList" class="clear-btn" title="Exit hot list mode">
      <i class="fas fa-times"></i>
    </button>
  </div>
</div> -->
      <!-- Results summary -->
      <div v-if="hasSearched && !isLoading" class="results-summary">
        <span v-if="totalResults > 0">
          Found <strong>{{ totalResults }}</strong> candidates
        </span>
        <span v-else>
          No candidates found. Try adjusting your search criteria.
        </span>
      </div>
   
      <!-- Pagination -->
      <!-- Simple pagination right under results -->
<div v-if="totalResults > 0" class="simple-pagination">
  <button
    :disabled="currentPage === 1"
    @click="goToPage(currentPage - 1)"
    class="simple-pagination-btn"
  >
    <i class="fas fa-chevron-left"></i>
  </button>
  
  <span class="simple-page-indicator">
    {{ currentPage }} / {{ maxPages }}
  </span>
  
  <button
    :disabled="currentPage === maxPages"
    @click="goToPage(currentPage + 1)"
    class="simple-pagination-btn"
  >
    <i class="fas fa-chevron-right"></i>
  </button>
</div>
    </div>
  </div>

  <!-- Loading overlay -->
  <div v-if="isLoading" class="loading-overlay">
    <div class="loading-content">
      <div class="loading-spinner"></div>
      <p class="loading-text">{{ loadingMessage }}</p>
    </div>
  </div>
</template>

<script>
import Checkbox from 'primevue/checkbox';
import Slider from 'primevue/slider';
import axios from "axios";
import InputText from "primevue/inputtext";
import Select from "primevue/select";
import MultiSelect from "primevue/multiselect";
import Textarea from 'primevue/textarea';
import NLSearchStream from './NLSearchStream.vue';
import { ref } from 'vue';  //  


export default {
  props: {
    userType: {
    type: String,
    default: null
  },
    projectContext: {
      type: Object,
      default: null
    }
  },
  
  emits: ['search-results', 'context-update', 'search-start'],
  name: "SearchSection",
  components: {
    InputText,
    Select,
    Checkbox,
    Slider,
    MultiSelect,
    Textarea,
    NLSearchStream 
  }, 
  setup(props, { emit }) {
  const useNLSearch = ref(false);
  const nlSearchActive = ref(false);
  const nlQuery = ref('');
  
  const toggleNLSearch = () => {
    useNLSearch.value = !useNLSearch.value;
    
    if (!useNLSearch.value) {
      nlSearchActive.value = false;
    }
  };

  const closeNLSearch = () => {
    nlSearchActive.value = false;
    useNLSearch.value = false;
  };

  const handleNLResults = (data) => {
    // ✅ Emit to parent so methods section can handle it
    emit('nl-results', data);
  };

  const handleNLError = (error) => {
    console.error('NL Search error:', error);
    nlSearchActive.value = false;
  };
  
  return {   
    useNLSearch,
    nlSearchActive,
    nlQuery,
    toggleNLSearch,
    closeNLSearch,
    handleNLResults,
    handleNLError,
  };
},
  data() {
    return {
            batchAddLoading: false,

      showAddAllBoard: false,
      addAllBoards: [],
      lastResultIds: [],  // candidate IDs from last search
      userRole: null,

          searchSetId: '',  // NEW: Add this
      useBooleanMode: false,  // NEW: Boolean search toggle
       // NEW: Snarky toast for single-word AI search
    showAIWarning: false,
    lastAIWarningTime: null,  // Track when we last warned

    aiWarningMessages: [
  "L'IA pour un mot ? Un peu overkill non ? 🎯",
  "Psst... essaye une vraie phrase pour l'IA 💬",
  "Un seul mot ? La recherche normale fera l'affaire 💡",
  "Sérieux ? L'IA pour un seul mot ? 🤨",
  "L'IA mérite mieux qu'un mot... essaye une phrase 😏"
],
// Hot List Integration
activeHotListId: null,
    activeHotListName: null,
    hotListCandidateIds: [],
    searchWithinHotList: false,
       // Contact filters 
    candidateId: "",
    candidateName: "",
    esDocumentId: "",  // NEW: Add this
    candidateEmail: "",
    candidatePhone: "",

      // UI State - FIXED: Use showFilters like the original
      showFilters: false,
      isLoading: false,
      loadingMessage: 'Searching...',
      hasSearched: false,
      activeFilters: new Set(), // FIXED: This manages which filter sections show
      
      // Search
      searchQuery: "",
      totalResults: 0,
      errorExists: false,
      errorMessage: "",
      pageSize: 10,
      pageOffset: 0,
      currentPage: 1,
      maxPages: 1,
      noResultsFound: false,
      
      // Experience filter
      experienceRange: [0, 180],
      experienceRangeMin: 0,
      experienceRangeMax:180 ,
      
      // Skills
      selectedSkills: [],
      skillFilterValue: '',
      skillsDropdownKey: 0,  // ✅ NEW: Forces re-render


      skillOptions: [],
      isLoadingSkills: false,
      skillSearchTimeout: null,
      
      // Locations
      selectedLocations: [],
      locationOptions: [],
      isLoadingLocations: false,
      
      // Seniority
      selectedSeniority: null,
      seniorityOptions: [],
      
      // Semantic search
      useRAGSearch: false,
      jobDescription: "",
      query: "",
      additionalContext: "",
      semanticSearchQuery: "",
      selectedVectorFields: ["summaries", "job_titles", "responsibilities", "skills"],
      minSemanticScore: 0.5,
      vectorFieldOptions: [
        { label: "Summaries", value: "summaries" },
        { label: "Job Titles", value: "job_titles" },
        { label: "Responsibilities", value: "responsibilities" },
        { label: "Skills", value: "skills" }
      ],
      semanticSearchActive: false,
      
      // NEW: Sort configuration
      selectedSort: 'relevance',  // Add this line
        sortOptions: [               // Add this array
          { label: 'Relevance', value: 'relevance', icon: 'fas fa-star' },
          { label: 'Most Recent', value: 'recent', icon: 'fas fa-clock' }
        ],
      selectedViewFilter: 'all',
      searchWithinResults: false,
      viewFilterOptions: [
        { label: 'All Profiles', value: 'all', icon: 'fas fa-globe' },
        { label: 'New Only', value: 'unseen', icon: 'fas fa-eye-slash' },
        { label: 'Seen Only', value: 'seen', icon: 'fas fa-eye' }
      ],
      // Quick filters configuration
      quickFilterOptions: [
        { key: 'contact', label: 'Contact', icon: 'fas fa-address-book' }, // contact
        { key: 'experience', label: 'Experience', icon: 'fas fa-briefcase' },
        { key: 'skills', label: 'Skills', icon: 'fas fa-cogs' },
        // { key: 'sort', label: 'Sort', icon: 'fas fa-sort' },  // sort by recency

        { key: 'location', label: 'Location', icon: 'fas fa-map-marker-alt' },
        { key: 'semantic', label: 'AI Search', icon: 'fas fa-brain' },
        { key: 'boolean', label: 'Boolean', icon: 'fas fa-code' },  // NEW bool

      ],
    
      
      // Debouncing
      searchTimeout: null,
      SEARCH_DELAY: 500
    };
  },
  computed: {
  
  showAgentBadge() {
    return this.userType === 'agent' || this.isAdminContext || this.hasProjectContext;
  },
  
  badgeText() {
    if (this.isAdminContext) return 'Admin';
    if (this.hasProjectContext) return 'Team';
    return 'Agents';
  },
  
  isAdminContext() {
    return this.$route.path.includes('/admin');
  },
  
  hasProjectContext() {
    return this.projectContext || this.$route.query.project_id;
  }
},
 async mounted() {
    try {
      const res = await axios.get('/api/v1/clients/user/type');
      this.userRole = res.data.user_type;
    } catch (e) { this.userRole = 'agent'; }
    // FIXED: Load initial filter options like the original
    this.fetchFilterOptions();
    console.log('🔧 SearchSection: Component mounted');
    this.handleQueryParameters();
  this._isMounted = true;

  },
  
  methods: {
    //batch add 
    async toggleAddAllBoard() {
      this.showAddAllBoard = !this.showAddAllBoard;
      if (this.showAddAllBoard && !this.addAllBoards.length) {
        try {
          const res = await axios.get('/api/v1/my-history/favorite-groups');
          this.addAllBoards = res.data.groups || [];
        } catch (e) { /**/ }
      }
    },

    async addAllToBoard(boardId) {
      const ids = this.lastResultIds.slice(0, 50);
      if (!ids.length) return;
      this.isLoading = true;
      this.loadingMessage = 'Ajout des candidats au Board..';


      try {
        const res = await axios.post('/api/v1/my-board/batch-add', {
          board_id: boardId,
          candidate_ids: ids
        });
        const added = res.data.added || 0;
        const skipped = res.data.skipped || 0;
        this.showAddAllBoard = false;
        alert(skipped > 0
          ? `${added} ajouté(s), ${skipped} déjà présent(s)`
          : `${added} candidat(s) ajouté(s) au board`);
      } catch (e) { console.error('Add all failed:', e); }
      finally { this.isLoading = false;       this.loadingMessage = 'Searching ...';    }

    },
    _buildSearchDescription() {
      const parts = [];
      if (this.searchQuery) parts.push(this.searchQuery);
      if (this.selectedSkills.length) {
        const skills = this.selectedSkills.map(s => typeof s === 'object' ? s.value : s).join(', ');
        parts.push(`[skills: ${skills}]`);
      }
      if (this.selectedLocations.length) {
        const locs = this.selectedLocations.map(l => typeof l === 'object' ? l.value : l).join(', ');
        parts.push(`[loc: ${locs}]`);
      }
      if (this.selectedSeniority) {
        const sen = typeof this.selectedSeniority === 'object' ? this.selectedSeniority.value : this.selectedSeniority;
        parts.push(`[${sen}]`);
      }
      if (this.experienceRange[0] > this.experienceRangeMin || this.experienceRange[1] < this.experienceRangeMax) {
        parts.push(`[exp: ${Math.round(this.experienceRange[0]/12)}-${Math.round(this.experienceRange[1]/12)}y]`);
      }
      if (this.candidateName?.trim()) parts.push(`[name: ${this.candidateName.trim()}]`);
      if (this.useBooleanMode) parts.push('[boolean]');
      if (this.searchSetId) parts.push('[NL search]');
      return parts.join(' ') || null;
    },
      // ✅ Handle NL results in methods (has access to this.*)
  handleNLResultsFromSetup(data) {
    this.totalResults = data.total_hits;
    this.nlSearchActive = false;
    this.showFilters = true;
    
    this.$emit("search-results", {
      results: data.results,
      total: data.total_hits,
      analysis: data.analysis,
      variants_generated: data.variants_generated,
      timestamp: Date.now(),
      searchQuery: `[AI: ${data.analysis?.original_query || this.searchQuery || ''}]`  // ← ADD

    });
    
    console.log('NL Search complete:', {
      total: data.total_hits,
      analysis: data.analysis
    });
  },
    async onSkillSelectionChange() {
  this.isLoadingSkills = true;
  try {
    // Normalize all selected skills to prevent parsing issues
    this.selectedSkills = this.selectedSkills.map(skill => {
      if (typeof skill === 'object') {
        return {
          label: this.normalizeSkill(skill.label),
          value: this.normalizeSkill(skill.value)
        };
      } else {
        const normalized = this.normalizeSkill(skill);
        return {
          label: normalized,
          value: normalized
        };
      }
    });
    
    console.log('🔧 Normalized selected skills:', this.selectedSkills);
    
    // ✅ NEW: Clear filter text and close dropdown
    this.skillFilterValue = '';
    this.skillsDropdownKey++;  // Forces complete re-render

    this.$nextTick(() => {
      // Force close the dropdown by blurring the input
      if (this.$refs.skillsMultiSelect?.$el) {
        const input = this.$refs.skillsMultiSelect.$el.querySelector('input');
        if (input) {
          input.blur();
        }
      }
    });
    
    // THIS IS KEY: Refresh dropdown to show coexisting skills
    await this.fetchFilterOptions();
    this.handleSearch();
  } finally {
    this.isLoadingSkills = false;
  }
},

// Hot List Methods
activateHotList(hotListData) {
  this.activeHotListId = hotListData.hot_list_id;
  this.activeHotListName = hotListData.name;
  this.hotListCandidateIds = hotListData.candidate_ids || [];
  this.searchWithinHotList = true;
  
  console.log('🔥 SearchSection: Hot list activated:', this.activeHotListName, this.hotListCandidateIds.length, 'candidates');
  
  // Optionally auto-search to show hot list immediately
  // this.viewHotListCandidates();
},

clearHotList() {
  this.activeHotListId = null;
  this.activeHotListName = null;
  this.hotListCandidateIds = [];
  this.searchWithinHotList = false;
  
  console.log('🚫 SearchSection: Hot list cleared');
  
  // Optionally clear results
  // this.resetAllFilters();
},

viewHotListCandidates() {
  // Show all hot list candidates immediately
  if (this.hotListCandidateIds.length > 40) {
    // Use search_set pattern for large lists
    this.createSearchSetAndSearch();
  } else {
    this.candidateId = this.hotListCandidateIds.join(',');
    this.handleSearch();
  }
},

async createSearchSetAndSearch() {
  try {
    const response = await axios.post('/api/v1/search-sets/', {
      candidate_ids: this.hotListCandidateIds,
      metadata: {
        hot_list_id: this.activeHotListId,
        hot_list_name: this.activeHotListName
      }
    });
    
    this.searchSetId = response.data.search_set_id;
    await this.handleSearch();
  } catch (error) {
    console.error('❌ Error creating search set:', error);
  }
},


    async searchForScreeningRequests(projectId) {
  console.log('🔍 SearchSection: Searching for screening requests for project:', projectId);
  
  try {
    // Call the backend endpoint to get candidates needing screening
    const response = await axios.get(`/api/v1/agent/projects/${projectId}/screening-requests`);
    const screeningRequests = response.data.screening_requests;
    
    console.log('🔍 Found screening requests:', screeningRequests);
    
    if (screeningRequests.length > 0) {
      // Convert to search results format
      const searchResults = {
        results: screeningRequests.map(request => ({
          _id: request.elasticsearch_id,
          _source: {
            personal_information: {
              name: request.name || 'Unknown',
              email: request.email,
              phone: request.phone
            },
            metadata: {
              candidate_id: request.elasticsearch_id
            }
          }
        })),
        timestamp: Date.now()
      };
      
      // Emit search results to parent
      this.$emit('search-results', searchResults);
      
      // Show success message
      this.showNotification(`Found ${screeningRequests.length} candidates needing screening`, 'info');
    } else {
      // No screening requests found
      this.$emit('search-results', { results: [], timestamp: Date.now() });
      this.showNotification('No screening requests found for this project', 'info');
    }
    
  } catch (error) {
    console.error('Error searching for screening requests:', error);
    this.showNotification('Failed to load screening requests', 'error');
    
    // Emit empty results on error
    this.$emit('search-results', { results: [], timestamp: Date.now() });
  }
},

async searchForScreeningCandidates(candidateIds) {
  console.log('🔍 SearchSection: Searching for screening candidates:', candidateIds);
  
  try {
    // Use combined_search with multiple candidate IDs
    const params = {
      skip: 0,
      limit: candidateIds.length,
      candidate_ids: candidateIds.join(',') // Pass multiple IDs
    };
    
    console.log('🔍 Batch screening search params:', params);
    
    const response = await axios.get('/api/v1/combined_search/', { params });
    const results = response.data.results || [];
    
    console.log('🔍 Found screening candidates:', results.length);
    
    if (results.length > 0) {
      // Emit search results to parent
      this.$emit('search-results', {
        results: results,
        timestamp: Date.now()
      });
      
      this.showNotification(`Loaded ${results.length} candidates needing screening`, 'success');
    } else {
      this.$emit('search-results', { results: [], timestamp: Date.now() });
      this.showNotification('No screening candidates found', 'info');
    }
    
  } catch (error) {
    console.error('Error searching for screening candidates:', error);
    this.showNotification('Failed to load screening candidates', 'error');
    this.$emit('search-results', { results: [], timestamp: Date.now() });
  }
},

// ALSO ADD this notification method if it doesn't exist:
showNotification(message, type = 'info') {
  // Emit to parent or use your existing notification system
  this.$emit('notification', { message, type });
  console.log(`${type.toUpperCase()}: ${message}`);
},
// handleQueryParameters() {
//   const query = this.$route.query;
//   console.log('🔍 SearchSection: Route query params:', query);
  
//   // Check if we have query parameters that should trigger a search
//   if (query.candidate_id || query.auto_search === 'true') {
//     console.log('🔍 SearchSection: Detected query parameters for auto-search', query);
    
//     // Set candidate ID if provided
//     if (query.candidate_id) {
//       this.candidateId = query.candidate_id;
//       console.log('🔍 SearchSection: Set candidateId to:', this.candidateId);
//     }
//       // NEW: Set search_set if provided
//     if (query.search_set) {
//       this.searchSetId = query.search_set;
//       console.log('🔍 SearchSection: Set searchSetId to:', this.searchSetId);
//     }
    
    
//     // Expand filters to show the search is active
//     this.showFilters = true;
    
//     // Auto-search if requested - but wait for filter options to load first
//     if (query.auto_search === 'true') {
//       console.log('🔍 SearchSection: Auto-triggering search in 2 seconds...');
      
//       // Wait longer for everything to be ready
//       setTimeout(async () => {
//         console.log('🔍 SearchSection: Now triggering search with candidateId:', this.candidateId);
//         await this.handleSearch();
//       }, 2000); // 2 second delay
//     }
//   } else {
//     console.log('🔍 SearchSection: No auto-search parameters found');
//   }
// },
handleQueryParameters() {
  const query = this.$route.query;
  console.log('🔍 SearchSection: Route query params:', query);
  
  // NEW: Handle ES ID search (takes priority - most specific)
  if (query.es_id) {
    this.esDocumentId = query.es_id;  // NEW: Add this to data()
    this.candidateId = '';  // Clear candidate_id if es_id is present
    console.log('🔍 SearchSection: Set esDocumentId to:', this.esDocumentId);
  }
  // Handle candidate ID search
  else if (query.candidate_id) {
    this.candidateId = query.candidate_id;
    this.esDocumentId = '';  // Clear es_id if candidate_id is present
    console.log('🔍 SearchSection: Set candidateId to:', this.candidateId);
  }
  
  // Handle search_set
  if (query.search_set) {
    this.searchSetId = query.search_set;
    console.log('🔍 SearchSection: Set searchSetId to:', this.searchSetId);
  }
  
  // Expand filters to show the search is active
  if (query.candidate_id || query.es_id || query.auto_search === 'true') {
    this.showFilters = true;
  }
   // Set the identifier
   if (query.es_id) {
      this.esDocumentId = query.es_id;
      this.candidateId = '';
    } else if (query.candidate_id) {
      this.candidateId = query.candidate_id;
      this.esDocumentId = '';
    }
  
  // Auto-search if requested
  if (query.auto_search === 'true') {
    console.log('🔍 SearchSection: Auto-triggering search...');
    // Clear all filters
    this.searchQuery = '';
    this.selectedSkills = [];  // ✅ This clears Python filter
    this.selectedLocations = [];
    this.selectedSeniority = null;
    this.experienceRange = [this.experienceRangeMin, this.experienceRangeMax];
    this.candidateName = '';
    this.candidateEmail = '';
    this.candidatePhone = '';
    
   
  //   setTimeout(async () => {
  //     await this.handleSearch();
  //     if (this.$route.query.auto_search) {
  //   this.$router.replace({ 
  //     path: this.$route.path,
  //     query: { ...this.$route.query, auto_search: undefined, from: undefined }
  //   });
  // }
  //   }, 8000);  // Reduced to 100ms - no need for 2 seconds
  // Wait for component to be ready, then search
  const trySearch = async (attempts = 0) => {
      if (attempts > 90) return; // give up after 3s
      if (!this._isMounted) {
        setTimeout(() => trySearch(attempts + 1), 100);
        return;
      }
      await this.handleSearch();
      if (this.$route.query.auto_search) {
        this.$router.replace({
          path: this.$route.path,
          query: { ...this.$route.query, auto_search: undefined, from: undefined }
        });
      }
    };
    trySearch();
  }
},
    // Get contact chips for display
getContactChips() {
  const chips = [];
  if (this.candidateId) chips.push({ key: 'candidateId', label: 'ID', value: this.candidateId });
  if (this.candidateName) chips.push({ key: 'candidateName', label: 'Name', value: this.candidateName });
  if (this.candidateEmail) chips.push({ key: 'candidateEmail', label: 'Email', value: this.candidateEmail });
  if (this.candidatePhone) chips.push({ key: 'candidatePhone', label: 'Phone', value: this.candidatePhone });
  return chips;
},
hasSearchCriteria() {
  return this.searchQuery || 
    this.candidateId || 
    this.candidateName || 
    this.candidateEmail || 
    this.candidatePhone || 
    this.selectedSkills.length > 0 || 
    this.selectedSeniority || 
    this.minExperienceMonths > 0 || 
    this.selectedLocations.length > 0;
},

// Clear individual contact field
clearContactField(fieldKey) {
  this[fieldKey] = '';
  this.handleSearch(); // Change from debouncedSearch() to handleSearch()
},
    // FIXED: Expand search function
    expandSearch() {
      if (!this.showFilters) {
        this.showFilters = true;
        this.$nextTick(() => {
          if (this.$refs.searchInput) {
            this.$refs.searchInput.focus();
          }
        });
      }
    },
    
    // FIXED: Debounced search 
    debouncedSearch() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      
      this.searchTimeout = setTimeout(() => {
        if (this.searchQuery.trim()) {
          this.handleSearch();
        }
      }, this.SEARCH_DELAY);
    },
    
    // FIXED: Quick filter management
    toggleQuickFilter(filterKey) {
      // Special handling for boolean mode (doesn't expand section, just toggles state)
    if (filterKey === 'boolean') {
      this.useBooleanMode = !this.useBooleanMode;
      
      // Update active state for visual feedback
      if (this.useBooleanMode) {
        this.activeFilters.add('boolean');
      } else {
        this.activeFilters.delete('boolean');
      }
      
      // Auto-search if user has criteria
      if (this.hasSearchCriteria()) {
        this.handleSearch();
      }
      return;
    }
      if (this.activeFilters.has(filterKey)) {
        this.activeFilters.delete(filterKey);
      } else {
        this.activeFilters.add(filterKey);
      }
    },
    
    // FIXED: Reset filters method
    resetAllFilters() {
      this.activeFilters.clear();
      this.selectedSkills = [];
      this.selectedLocations = [];
      this.experienceRange = [0, 6000];
      this.useRAGSearch = false;
      this.jobDescription = "";
      this.query = "";
      this.additionalContext = "";
      this.semanticSearchQuery = "";
      this.searchQuery = "";
      this.hasSearched = false;
      this.totalResults = 0;
       // Clear contact filters
      this.candidateId = "";
      this.candidateName = ""; 
      this.candidateEmail = "";
      this.candidatePhone = "";
      this.esDocumentId = "";  // NEW: es id
      this.selectedSort = 'relevance';  // reset sort
      this.searchWithinHotList = false;
      this.selectedViewFilter = 'all';
      this.searchWithinResults = false;
      this.lastResultIds = [];
       
  this.useBooleanMode = false;
  this.searchSetId = '';


      this.$emit('search-results', { results: [], timestamp: Date.now() });
    },
    
    clearSearch() {
      this.searchQuery = "";
      this.resetAllFilters();
    },
    
    // FIXED: Fetch filter options with coexistence logic
    async fetchFilterOptions() {
      console.log("🔄 fetchFilterOptions called");
      
      try {
        // CRITICAL: Pass selected skills to get coexisting skills
        const selectedSkillsParam = this.selectedSkills.length > 0 
          ? this.selectedSkills.map(s => typeof s === 'object' ? s.value : s).join(',')
          : null;
        
        const skillParams = { max_skills: 30 };
        if (selectedSkillsParam) {
          skillParams.selected_skills = selectedSkillsParam;
          console.log("🔄 Fetching skills that coexist with:", selectedSkillsParam);
        }

        const skillsResponse = await axios.get(`/api/v1/get_all_skills/`, {
          params: skillParams
        });        
        
        if (skillsResponse.data && skillsResponse.data.skills) {
          // Apply skill validation like the original
          const validSkills = skillsResponse.data.skills.filter(skill => this.isValidSkill(skill));
          
          this.skillOptions = validSkills.map(skill => ({
            label: skill,
            value: skill
          }));
          
          console.log(`🔄 Loaded ${this.skillOptions.length} valid skills (filtered out ${skillsResponse.data.skills.length - validSkills.length} bad ones)`);
        }
        
        // Locations (existing logic)
        try {
          const locationsResponse = await axios.get(`/api/v1/get_all_locations/`, {
            params: { max_locations: 30 }
          });
          
          if (locationsResponse.data && locationsResponse.data.locations) {
            this.locationOptions = locationsResponse.data.locations.map(location => ({
              label: location,
              value: location
            }));
            console.log("🔄 Loaded", this.locationOptions.length, "location options");
          } else {
            this.setDefaultLocations();
          }
        } catch (e) {
          console.error("❌ Failed to fetch locations:", e);
          this.setDefaultLocations();
        }
        
        // Seniority (existing logic)
        try {
          const seniorityResponse = await axios.get(`/api/v1/get_all_seniority_levels/`);
          if (seniorityResponse.data && seniorityResponse.data.seniority_levels) {
            this.seniorityOptions = seniorityResponse.data.seniority_levels.map(level => ({
              label: level.charAt(0).toUpperCase() + level.slice(1),
              value: level
            }));
            console.log("🔄 Loaded", this.seniorityOptions.length, "seniority options");
          } else {
            this.setDefaultSeniority();
          }
        } catch (e) {
          console.warn("❌ Could not fetch seniority levels:", e);
          this.setDefaultSeniority();
        }
      } catch (error) {
        console.error("Failed to load filter options:", error);
        this.setDefaultFilterOptions();
      }
    },
    
    // FIXED: Skills filter with API calls and validation
    async onSkillFilter(event) {
      const query = event.value?.trim();

      if (!query) {
        return this.fetchFilterOptions();
      }

      const selectedSkillsParam = this.selectedSkills.length > 0 
        ? this.selectedSkills.map(s => typeof s === 'object' ? s.value : s).join(',')
        : null;
      
      try {
        const params = { query: query };
        if (selectedSkillsParam) {
          params.selected_skills = selectedSkillsParam;
          console.log("🔍 Searching skills with query:", query, "and selected:", selectedSkillsParam);
        }
     
        const response = await axios.get(`/api/v1/get_all_skills/`, {
          params: params
        });
        
        if (response.data && response.data.skills) {
          // Apply skill validation like the original
          const validSkills = response.data.skills.filter(skill => this.isValidSkill(skill));
          
          const newSkills = validSkills.map(skill => ({
            label: skill,
            value: skill
          }));
          
          if (newSkills.length > 0) {
            this.skillOptions = newSkills;
            console.log(`🔍 Found ${newSkills.length} valid skills for "${query}" (filtered out ${response.data.skills.length - validSkills.length} bad ones)`);
          } else {
            console.log(`🔍 No valid skills found for "${query}", falling back...`);
            await this.fetchFilterOptions();
          }
        } else {
          await this.fetchFilterOptions();
        }
      } catch (error) {
        console.error("❌ Error in skill filter:", error);
        await this.fetchFilterOptions();
      }
    },
    
    // FIXED: Location search with proper API calls
    async searchLocations(event) {
      console.log("🌍 searchLocations triggered with event:", event);
      
      const query = event.value?.trim();
      console.log("🌍 Query after trim:", query);
      
      if (!query) {
        console.log("🌍 Empty query, fetching default locations");
        return this.fetchFilterOptions();
      }
      
      // Query backend for any non-empty string
      console.log("🌍 Non-empty query detected, querying backend...");
      
      try {
        const params = { query: query.toLowerCase() };
        console.log("🌍 API request params:", params);
        console.log("🌍 Making request to /api/v1/get_all_locations/");
        
        const response = await axios.get(`/api/v1/get_all_locations/`, {
          params: params
        });
        
        console.log("🌍 Locations API response:", response.data);
        
        if (response.data && response.data.locations) {
          this.locationOptions = response.data.locations.map(location => ({
            label: location,
            value: location
          }));
          console.log("🌍 Updated locationOptions:", this.locationOptions.slice(0, 5)); // First 5 for brevity
        } else {
          console.warn("🌍 No locations in response");
        }
      } catch (error) {
        console.error("❌ Error filtering locations:", error);
        console.error("❌ Error response:", error.response?.data);
        console.error("❌ Error status:", error.response?.status);
        
        // Fallback: don't crash, keep existing options
        console.log("🌍 Keeping existing location options due to error");
      }
    },
    
    // FIXED: Skill validation methods from original
    isValidSkill(skill) {
      if (!skill || typeof skill !== 'string') return false;
      
      // Filter out skills with problematic characters
      const hasCommas = skill.includes(',');
      const hasParentheses = skill.includes('(') && skill.includes(')');
      const isTooLong = skill.length > 80;
      const hasTooManyWords = skill.split(' ').length > 8;
      const hasColons = skill.includes(':');
      
      // If any problematic pattern found, reject it
      if (hasCommas || (hasParentheses && hasTooManyWords) || isTooLong || hasColons) {
        console.log(`🚫 Filtering out malformed skill: "${skill.substring(0, 50)}..."`);
        return false;
      }
      
      return true;
    },

    normalizeSkill(skill) {
      if (!skill) return skill;
      
      let normalized = typeof skill === 'object' ? skill.value || skill.label : skill;
      
      // Replace problematic characters that break comma-separated parsing
      normalized = normalized
        // Replace commas with " and " to maintain readability
        .replace(/,\s*/g, ' and ')
        // Replace multiple spaces with single space
        .replace(/\s+/g, ' ')
        // Trim whitespace
        .trim();
      
      // Truncate if too long (optional)
      if (normalized.length > 80) {
        normalized = normalized.substring(0, 77) + '...';
      }
      
      return normalized;
    },

    // FIXED: Skills selection change - refreshes dropdown AND searches
    // async onSkillSelectionChange() {
    //   this.isLoadingSkills = true;
    //   try {
    //     // Normalize all selected skills to prevent parsing issues
    //     this.selectedSkills = this.selectedSkills.map(skill => {
    //       if (typeof skill === 'object') {
    //         return {
    //           label: this.normalizeSkill(skill.label),
    //           value: this.normalizeSkill(skill.value)
    //         };
    //       } else {
    //         const normalized = this.normalizeSkill(skill);
    //         return {
    //           label: normalized,
    //           value: normalized
    //         };
    //       }
    //     });
        
    //     console.log('🔧 Normalized selected skills:', this.selectedSkills);
        
    //     // THIS IS KEY: Refresh dropdown to show coexisting skills
    //     await this.fetchFilterOptions();
    //     this.handleSearch();
    //   } finally {
    //     this.isLoadingSkills = false;
    //   }
    // },
    
    removeSkill(skill) {
      const skillToRemove = this.normalizeSkill(skill);
      
      // Create new filtered array
      const newSelectedSkills = this.selectedSkills.filter(s => {
        const currentValue = typeof s === 'object' && s.value !== undefined ? s.value : s;
        return currentValue !== skillToRemove;
      });
      
      // Check if this is removing the last skill AND there are no other search criteria
      const removingLastSkill = newSelectedSkills.length === 0 && this.selectedSkills.length === 1;
      
      if (removingLastSkill) {
        this.selectedSkills = [];
        this.$emit("search-results", {
          results: [],
          timestamp: Date.now(),
        });
      } else {
        this.selectedSkills = newSelectedSkills;
        // Refresh dropdown and search
        this.onSkillSelectionChange();
      }
    },
    
    onLocationSelectionChange() {
      this.handleSearch();
    },
    
    removeLocation(location) {
      const locationToRemove = typeof location === 'object' ? location.value : location;
      this.selectedLocations = this.selectedLocations.filter(l => {
        const currentValue = typeof l === 'object' ? l.value : l;
        return currentValue !== locationToRemove;
      });
      this.handleSearch();
    },
    
    // Experience methods
    getExperienceRangeLabel() {
      const minYears = this.experienceToYears(this.experienceRange[0]);
      const maxYears = this.experienceToYears(this.experienceRange[1]);
      
      if (this.experienceRange[0] === this.experienceRangeMin && 
          this.experienceRange[1] === this.experienceRangeMax) {
        return 'Any experience';
      }
      
      if (this.experienceRange[1] === 900) {
        return `${minYears}+ experience`;
      }
      
      if (this.experienceRange[0] === this.experienceRangeMin) {
        return `Up to ${maxYears} experience`;
      }
      
      return `${minYears} - ${maxYears} experience`;
    },
    
    onExperienceRangeChange() {
      this.experienceRange[0] = Math.round(this.experienceRange[0] / 6) * 6;
      this.experienceRange[1] = Math.round(this.experienceRange[1] / 6) * 6;
      this.handleSearch();
    },
    
    setExperiencePreset(range) {
      this.experienceRange = [...range];
      this.handleSearch();
    },
    
    experienceToYears(months) {
      if (months === 0) return '0';
      if (months < 12) return `${months}m`;
      
      const years = months / 12;
      if (years % 1 === 0) {
        return `${years}y`;
      } else {
        const roundedYears = Math.round(years * 2) / 2;
        return `${roundedYears}y`;
      }
    },
    
    toggleRAGFields() {
      if (!this.useRAGSearch) {
        this.jobDescription = "";
        this.query = "";
        this.additionalContext = "";
      }
    },
    
    clearSemanticFields() {
      this.jobDescription = "";
      this.query = "";
      this.additionalContext = "";
      this.semanticSearchQuery = "";
      this.useRAGSearch = false;
    },
    
    // FIXED: Main search method using original working logic
  // Also update your handleSearch method to add debugging:
// async handleSearch(resetPagination = true) {
//   console.log('🔍 handleSearch called with candidateId:', this.candidateId);
//   const handleSearch = async () => {
//   if (!searchQuery.value.trim()) return;
  
//   // If NL Search is enabled, trigger streaming search
//   if (useNLSearch.value) {
//     nlQuery.value = searchQuery.value;
//     nlSearchActive.value = true;
//     return;  // Exit early, NLSearchStream handles the rest
//   }
  
//   if (resetPagination) {
//     this.currentPage = 1;
//     this.pageOffset = 0;
//   }
  
//   if (!this.searchQuery && 
//       !this.candidateId &&
//       !this.searchSetId &&  // NEW: search set
//       !this.esDocumentId &&  // NEW: search id
//       !this.candidateName &&        
//       !this.candidateEmail &&
//       !this.candidatePhone &&       
//       this.selectedSkills.length === 0 && 
//       this.selectedLocations.length === 0 && 
//       (this.experienceRange[0] <= this.experienceRangeMin && this.experienceRange[1] >= this.experienceRangeMax)) {
//     console.log('🔍 handleSearch: No search criteria, returning early');
//     return;
//   }

//   console.log('🔍 handleSearch: Proceeding with search...');
//   this.isLoading = true;
//   this.hasSearched = true;
//   this.errorExists = false;

//   try {
//     const params = {
//       skip: this.pageOffset,
//       limit: this.pageSize,
//       boolean_mode: this.useBooleanMode,
//     };

//     // NEW: ES ID takes priority (most specific)
//     // if (this.esDocumentId) {
//     //   params.es_id = this.esDocumentId;
//     //   console.log('🔍 handleSearch: Added es_id to params:', this.esDocumentId);
//     // }
//     // // Then candidate_id
//     // else if (this.candidateId) {
//     //   params.candidate_id = this.candidateId;
//     //   console.log('🔍 handleSearch: Added candidate_id to params:', this.candidateId);
//     // }

//     // 🔥 HOT LIST: Restrict to hot list candidates if active
//     if (this.searchWithinHotList && this.hotListCandidateIds.length > 0) {
//       // User is searching WITHIN hot list
//       params.candidate_id = this.hotListCandidateIds.join(',');
//       console.log('🔥 Searching within hot list:', this.activeHotListName, '(', this.hotListCandidateIds.length, 'candidates)');
//     }
//     // ES ID takes priority (if not in hot list mode)
//     else if (this.esDocumentId) {
//       params.es_id = this.esDocumentId;
//       console.log('🔍 handleSearch: Added es_id to params:', this.esDocumentId);
//     }
//     // Then candidate_id
//     else if (this.candidateId) {
//       params.candidate_id = this.candidateId;
//       console.log('🔍 handleSearch: Added candidate_id to params:', this.candidateId);
//     }
//     // NEW: Add search_set if present
//     if (this.searchSetId) {
//       params.search_set = this.searchSetId;
//       console.log('🔍 handleSearch: Added search_set to params:', this.searchSetId);
//     }
//     // candidate filters
//     if (this.searchQuery) {
//       params.query = this.searchQuery;
//     }

//     if (this.experienceRange[0] > this.experienceRangeMin) {
//       params.min_experience_months = Math.round(this.experienceRange[0]);
//     }
//     if (this.experienceRange[1] < this.experienceRangeMax) {
//       params.max_experience_months = Math.round(this.experienceRange[1]);
//     }

//     if (this.selectedSkills && this.selectedSkills.length > 0) {
//       params.skills = this.selectedSkills
//         .map(skill => typeof skill === 'object' ? skill.value : skill)
//         .join(',');
//     }

//     if (this.selectedLocations && this.selectedLocations.length > 0) {
//       params.locations = this.selectedLocations
//         .map(location => typeof location === 'object' ? location.value : location)
//         .join(',');
//     }

//     if (this.selectedSeniority) {
//       params.seniority = typeof this.selectedSeniority === 'object'
//         ? this.selectedSeniority.value
//         : this.selectedSeniority;
//     }
//      // NEW:sort parameter
//     if (this.selectedSort && this.selectedSort !== 'relevance') {
//           params.sort_by = this.selectedSort;
//         }
//     // // ADD CONTACT PARAMS
//     // if (this.candidateId) {
//     //   params.candidate_id = this.candidateId;
//     //   console.log('🔍 handleSearch: Added candidate_id to params:', this.candidateId);
//     // }
    
//     if (this.candidateName) {
//       params.candidate_name = this.candidateName;
//     }
    
//     if (this.candidateEmail) {
//       params.candidate_email = this.candidateEmail;
//     }
    
//     if (this.candidatePhone) {
//       params.candidate_phone = this.candidatePhone;
//     }

//     console.log("🔍 Search params:", params);

//     const response = await axios.get(`/api/v1/combined_search/`, { params });
    
//     const results = response.data.results || [];
//     this.totalResults = response.data.total_hits || 0;
//     this.maxPages = response.data.max_pages || 1;
//     this.noResultsFound = results.length === 0;

//     this.$emit("search-results", {
//       results: results,
//       total: response.data.total,          // NEW: For future use
//       max_score: response.data.max_score,  // NEW: For score_percent
//       took: response.data.took,            // NEW: For metrics
//       timestamp: Date.now(),
//       sortBy: this.selectedSort //sorting by recency to emit
//     });
    
//     console.log('🔍 Search completed, found:', results.length, 'results');
    
//   } catch (error) {
//     console.error("Search error:", error);
//     this.errorMessage = error.response
//       ? error.response.data.detail || "An error occurred."
//       : 'An error occurred. Please try again.';
//     this.errorExists = true;
//     this.$emit("search-results", { 
//       results: [], 
//       timestamp: Date.now() 
//     });
//   } finally {
//     this.isLoading = false;
//   }
// };
// },
handleNLSearchClose() {
  // Only close if user explicitly closes, not on navigation
  this.nlSearchActive = false;
  // Don't set nlQuery = '' here - keep it for reference
},

handleNLSearchViewResults(results) {
  // NLSearchStream will handle navigation
  // Just keep nlSearchActive true so panel stays visible (collapsed)
  console.log('🔍 NL Search view results triggered');
},
async handleSearch(resetPagination = true) {
  console.log('🔍 handleSearch called');
  
  // NEW: Special case - auto-search from NL should force normal mode
  // ✅ Check if this is an auto_search from NL results (search_set present)
  // In this case, we want NORMAL search even if useNLSearch toggle is on
  // const isAutoSearchFromNL = this.$route.query.auto_search === 'true' && this.$route.query.search_set;
  // if (!isAutoSearchFromNL) {
  //   // This is a fresh user-initiated search, clear the search_set
  //   this.searchSetId = '';
  //   console.log('🔍 Cleared searchSetId for fresh search');
  // }
  
  const isAutoSearchFromNL = this.$route.query.auto_search === 'true' && this.$route.query.search_set;
  if (!isAutoSearchFromNL && resetPagination) {
    this.searchSetId = '';
    console.log('🔍 Cleared searchSetId for fresh search');
  }
  if (isAutoSearchFromNL && resetPagination) {
    this.$router.replace({ query: {} });
  }
  if (isAutoSearchFromNL) {
    
    console.log('🔍 Auto-search from NL results - using normal search mode');
    // Don't reset useNLSearch toggle - just skip NL mode for this search
    // This allows user to do another AI search later
  }
  else if (this.useNLSearch && this.searchQuery) {
    // ✅ NEW: Check if query is just one word
    const wordCount = this.searchQuery.trim().split(/\s+/).length;
    
    if (wordCount === 1) {
      const now = Date.now();
      const timeSinceWarning = this.lastAIWarningTime ? (now - this.lastAIWarningTime) : Infinity;
      if (timeSinceWarning > 10000) {

      // Show snarky warning
      const randomMsg = this.aiWarningMessages[
        Math.floor(Math.random() * this.aiWarningMessages.length)
      ];
      this.aiWarningMessage = randomMsg;
      this.showAIWarning = true;
      this.lastAIWarningTime = now;

      
      // Auto-dismiss after 3 seconds
      setTimeout(() => {
        this.showAIWarning = false;
      }, 10000);
      // Still allow the search (user might insist)
      console.log('🚫 Blocked single-word AI search');
      return; //blocking
    }else{
// Second attempt within 10sec - auto-switch to normal
console.log('🔄 User insists - switching to normal search');
        this.useNLSearch = false;
        this.lastAIWarningTime = null;
        
        // Show quick feedback
        this.aiWarningMessage = "OK OK... recherche normale 👌";
        this.showAIWarning = true;
        setTimeout(() => { this.showAIWarning = false; }, 10000);
        
        // Fall through to normal search below

    }
  }else{
    // ✅ Only trigger NL search if:
    // 1. Toggle is on
    // 2. There's a query
    // 3. NOT an auto-search from NL results
    // console.log('🔍 NL Search mode active, triggering AI agent');
    // this.nlQuery = this.searchQuery;
    // this.nlSearchActive = true;
    // return
      // ✅ Reset NL state to allow fresh search
    this.nlSearchActive = false;
    this.$nextTick(() => {
      this.nlQuery = this.searchQuery;
      this.nlSearchActive = true;
    });
    
    return;
  }
  };
  // Also clear auto-search candidate filters on fresh search
  if (resetPagination && !isAutoSearchFromNL && !this.$route.query.auto_search) {
    if (this.$route.query.candidate_id && this.candidateId === this.$route.query.candidate_id) {
      this.candidateId = '';
    }
    if (this.$route.query.es_id && this.esDocumentId === this.$route.query.es_id) {
      this.esDocumentId = '';
    }
  }
  
  
  // ✅ Rest of your normal search logic
  if (resetPagination) {
    this.currentPage = 1;
    this.pageOffset = 0;
  }
  
  if (!this.searchQuery && 
      !this.candidateId &&
      !this.searchSetId &&
      !this.esDocumentId &&
      !this.candidateName &&        
      !this.candidateEmail &&
      !this.candidatePhone &&       
      this.selectedSkills.length === 0 && 
      this.selectedLocations.length === 0 && 
      (this.experienceRange[0] <= this.experienceRangeMin && 
       this.experienceRange[1] >= this.experienceRangeMax)) {
    console.log('🔍 handleSearch: No search criteria, returning early');
    return;
  }

  console.log('🔍 handleSearch: Proceeding with search...');
  this.isLoading = true;
  this.hasSearched = true;
  this.errorExists = false;

  try {
    const params = {
      skip: this.pageOffset,
      limit: this.pageSize,
      boolean_mode: this.useBooleanMode,
    };

    // Hot list mode
    if (this.searchWithinHotList && this.hotListCandidateIds.length > 0) {
      params.candidate_id = this.hotListCandidateIds.join(',');
    }
    else if (this.esDocumentId) {
      params.es_id = this.esDocumentId;
    }
    else if (this.candidateId) {
      params.candidate_id = this.candidateId;
    }
    
    if (this.searchSetId) {
      params.search_set = this.searchSetId;
    }
    // Constrain to current result set if toggle is on
    // Constrain to current result set if toggle is on
    // if (this.searchWithinResults && !params.search_set && !params.candidate_id && this.lastResultIds.length) {
    //   params.candidate_id = this.lastResultIds.join(',');
    // }
    
    if (this.searchQuery) {
      params.query = this.searchQuery;
    }

    if (this.experienceRange[0] > this.experienceRangeMin) {
      params.min_experience_months = Math.round(this.experienceRange[0]);
    }
    if (this.experienceRange[1] < this.experienceRangeMax) {
      params.max_experience_months = Math.round(this.experienceRange[1]);
    }

    if (this.selectedSkills && this.selectedSkills.length > 0) {
      params.skills = this.selectedSkills
        .map(skill => typeof skill === 'object' ? skill.value : skill)
        .join(',');
    }

    if (this.selectedLocations && this.selectedLocations.length > 0) {
      params.locations = this.selectedLocations
        .map(location => typeof location === 'object' ? location.value : location)
        .join(',');
    }

    if (this.selectedSeniority) {
      params.seniority = typeof this.selectedSeniority === 'object'
        ? this.selectedSeniority.value
        : this.selectedSeniority;
    }
    
    if (this.selectedSort && this.selectedSort !== 'relevance') {
      params.sort_by = this.selectedSort;
    }
    
    if (this.candidateName) {
      params.candidate_name = this.candidateName;
    }
    
    if (this.candidateEmail) {
      params.candidate_email = this.candidateEmail;
    }
    
    if (this.candidatePhone) {
      params.candidate_phone = this.candidatePhone;
    }
    if (this.selectedViewFilter && this.selectedViewFilter !== 'all') {
      params.view_filter = this.selectedViewFilter;
    }
    if (this.candidateName?.trim()) {
      params.candidate_name = this.candidateName.trim();
    }
    if (this.candidateEmail?.trim()) {
      params.candidate_email = this.candidateEmail.trim();
    }
    if (this.candidatePhone?.trim()) {
      params.candidate_phone = this.candidatePhone.trim();
    }
    console.log("🔍 Search params:", params);

    const response = await axios.get(`/api/v1/combined_search/`, { params });
    
    const results = response.data.results || [];
    this.totalResults = response.data.total_hits || 0;
    this.maxPages = response.data.max_pages || 1;
    this.noResultsFound = results.length === 0;
    this.lastResultIds = results.map(r => 
      r?.metadata?.candidate_id || r?.UID?.candidate_id
    ).filter(Boolean);
    this.$emit("search-results", {
      results: results,
      total: response.data.total,
      max_score: response.data.max_score,
      took: response.data.took,
      timestamp: Date.now(),
      sortBy: this.selectedSort,
      searchQuery: this._buildSearchDescription()  // ← full desc

    });
    
    console.log('🔍 Search completed, found:', results.length, 'results');
    
  } catch (error) {
    console.error("Search error:", error);
    this.errorMessage = error.response
      ? error.response.data.detail || "An error occurred."
      : 'An error occurred. Please try again.';
    this.errorExists = true;
    this.$emit("search-results", { 
      results: [], 
      timestamp: Date.now() 
    });
  } finally {
    this.isLoading = false;
  }
},


    // Semantic search methods
    async handleSemanticSearch(resetPagination = true) {
      if (!this.semanticSearchQuery || this.selectedVectorFields.length === 0) {
        this.errorMessage = "Please enter a semantic query and select at least one field.";
        this.errorExists = true;
        return;
      }
      
      this.isLoading = true;
      this.errorExists = false;
      
      try {
        const params = {
          query_text: this.semanticSearchQuery,
          field_types: this.selectedVectorFields.join(','),
          min_score: this.minSemanticScore,
          skip: this.pageOffset,
          limit: this.pageSize
        };
        
        const response = await axios.get(`/api/v1/semantic_search_multi/`, { params });
        
        const results = response.data.results || [];
        this.totalResults = response.data.total_hits || 0;
        this.maxPages = response.data.max_pages || 1;
        this.noResultsFound = results.length === 0;
        this.semanticSearchActive = true;
        

        this.$emit("search-results", {
          results: results,
          total: response.data.total,
          max_score: response.data.max_score,
          took: response.data.took,
          total_hits: this.totalResults,
          max_pages: this.maxPages,
          timestamp: Date.now(),
          timestamp: Date.now(),
          searchType: 'semantic'
        });
      } catch (error) {
        console.error("Semantic search error:", error);
        this.errorMessage = error.response
          ? error.response.data.detail || "An error occurred."
          : 'An error occurred. Please try again.';
        this.errorExists = true;
        this.$emit("search-results", { 
          results: [], 
          timestamp: Date.now() 
        });
      } finally {
        this.isLoading = false;
      }
    },
    
    async performRAGSearch(resetPagination = true) {
      if (!this.query.trim()) return;
      
      this.loadingMessage = 'AI is analyzing your requirements...';
      this.isLoading = true;
      
      try {
        const ragRequest = {
          query: this.semanticSearchQuery || this.query,
          top_k: this.pageSize,
          min_score: this.minSemanticScore,
          job_description: this.jobDescription,
          additional_context: this.additionalContext||"" ,
          language: 'fr'
        };
        
        console.log("RAG search request:", ragRequest);
        
        const response = await axios.post(`/api/v1/rag_search/`, ragRequest);
        
        const results = response.data.results || [];
        this.totalResults = results.length || 0;
        this.maxPages = 1;
        this.noResultsFound = results.length === 0;
        
        this.$emit("search-results", {
          results: results,
          total: response.data.total,
          max_score: response.data.max_score,
          took: response.data.took,
          analysis: response.data.analysis,
          analysisInFrench: response.data.analysis_french || response.data.analysis,
          recommendedCandidates: response.data.recommended_candidates,
          reasoning: response.data.reasoning,
          timestamp: Date.now(),
          searchType: 'rag'
        });
      } catch (error) {
        console.error("RAG search error:", error);
        this.errorMessage = error.response
          ? error.response.data.detail || "An error occurred."
          : 'An error occurred. Please try again.';
        this.errorExists = true;
        this.$emit("search-results", { 
          results: [], 
          timestamp: Date.now() 
        });
      } finally {
        this.isLoading = false;
      }
    },
    
    setDefaultLocations() {
      this.locationOptions = [
        { label: "Casablanca", value: "Casablanca" },
        { label: "Rabat", value: "Rabat" },
        { label: "Marrakech", value: "Marrakech" },
        { label: "Tangier", value: "Tangier" },
        { label: "Fes", value: "Fes" },
        { label: "Agadir", value: "Agadir" }
      ];
    },
    
    setDefaultSeniority() {
      this.seniorityOptions = [
        { label: "Junior", value: "junior" },
        { label: "Mid-level", value: "mid" },
        { label: "Senior", value: "senior" }
      ];
    },
    
    setDefaultFilterOptions() {
      this.setDefaultLocations();
      this.setDefaultSeniority();
    },
    goToPage(page) {
      if (page < 1 || page > this.maxPages) return;
      
      this.currentPage = page;
      this.pageOffset = (page - 1) * this.pageSize;
      
      // Call the appropriate search method
      if (this.semanticSearchActive) {
        if (this.useRAGSearch) {
          this.performRAGSearch(false);  // Pass false to not reset
        } else {
          this.handleSemanticSearch(false);  // Pass false to not reset
        }
      } else {
        this.handleSearch(false);  // ❌ Pass false to not reset pagination
      }
    },
  },
  watch: {
  '$route'( to, from) {
    // Only re-parse query params on actual navigation, not pagination-triggered replaces
    if (to.path !== from.path || to.query.auto_search) {
      this.handleQueryParameters();
    }
    console.log('🔍 SearchSection: Route changed, checking query parameters');
    // this.handleQueryParameters();
  }, 
  'selectedSkills'(newVal, oldVal) {
    if (newVal.length < oldVal.length) {
      // A skill was removed (backspace or X) — no need to search, just ensure clean state
      console.log('🏷️ Skill removed, new count:', newVal.length);
    }
  },
 'candidateId'(val) {
    const clean = val?.trim();
    if (!clean && val) { this.candidateId = ''; return; } // spaces → clear
    if (!clean && this.hasSearched) this.handleSearch();
  },
  'candidateName'(val) {
    const clean = val?.trim();
    if (!clean && val) { this.candidateName = ''; return; }
    if (!clean && this.hasSearched) this.handleSearch();
  },
  'candidateEmail'(val) {
    const clean = val?.trim();
    if (!clean && val) { this.candidateEmail = ''; return; }
    if (!clean && this.hasSearched) this.handleSearch();
  },
  'candidatePhone'(val) {
    const clean = val?.trim();
    if (!clean && val) { this.candidatePhone = ''; return; }
    if (!clean && this.hasSearched) this.handleSearch();
  },
  'searchQuery'(val) {
    if (!val && this.hasSearched && !this.candidateId && !this.searchSetId && 
        !this.selectedSkills.length && !this.selectedLocations.length) {
      // Query was the only criteria and it's now empty — clear results
      this.$emit('search-results', { results: [], timestamp: Date.now() });
      this.hasSearched = false;
      this.totalResults = 0;
    }
  },
}
};
</script>

<style scoped>
/* CSS Variables */
:root {
  --primary-color: #ea5e13;
  --background-color: #262624;
  --text-color: #FAF9F6;
  --surface-color: rgba(255, 255, 255, 0.05);
  --border-color: rgba(234, 94, 19, 0.2);
  --hover-color: rgba(234, 94, 19, 0.1);
}

.search-wrapper {
  padding: 2rem 0 0.5rem auto; /* top, right, bottom, left */
  min-height: 200px;
}

.container {
  margin: 3rem auto 0.5rem auto; /* top, right, bottom, left */
  width: 95%;
  max-width: 1200px;
}

.logo-container {
  text-align: center;
}

.logo-container.with-subtext {
  margin-bottom: -2rem;
}

.logo-container.no-subtext {
  margin-bottom: 1rem;
}

.logo-container .main-logo {
  height: 4rem;
  width: auto;
}

.search-interface {
  max-width: 800px;
  margin: 0 auto;
}
 



 

.logo-wrapper {
  display: inline-block;
  text-align: left;
  position: relative;
}

.main-logo {
  height: 3rem;
  width: auto;
  display: block;
  margin: 0 auto;
}

.subtext-wrapper {
  display: flex;
  align-items: center;
  margin-top: -2.5rem;
  margin-right: -0.5rem;
  justify-content: flex-end; /* push subtext right under logo */
  gap: 0.3rem;
}

.teams-logo {
  height: 100px;
  width: auto;
 
}

.teams-label {
  color: #ccc; /* gray text */
  font-size: 0.9rem;
  font-weight: 500;
}
/* Search bar */
.search-bar {
  position: relative;
  display: flex;
  align-items: center;
  background: var(--surface-color);
  border: 1px solid var(--border-color);
  border-radius: 1.5rem;
  padding: 0.5rem 1rem;
  transition: all 0.3s ease;
}

.search-bar:focus-within,
.search-bar.expanded {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(234, 94, 19, 0.1);
}

.search-input {
  flex: 1;
  border: none;
  background: none;
  padding: 0.5rem;
  font-size: 1rem;
  color: var(--text-color);
}

.search-input:focus {
  outline: none;
}

.search-input::placeholder {
  color: rgba(250, 249, 246, 0.5);
}

.search-actions {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.clear-button,
.search-button {
  background: none;
  border: none;
  color: var(--text-color);
  padding: 0.5rem;
  cursor: pointer;
  border-radius: 0.5rem;
  transition: all 0.2s ease;
}

.clear-button:hover {
  background: var(--hover-color);
}

.search-button {
  background: var(--primary-color);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
}

.search-button:hover:not(:disabled) {
  background: #b74211;
}

.search-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Filters section */
.filters-section {
  margin-top: 1.5rem;
  padding: 1.5rem;
  background: var(--surface-color);
  border: 1px solid var(--border-color);
  border-radius: 1rem;
}

/* Quick filter pills */
.quick-filters {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.filter-pill {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: none;
  border: 1px solid var(--border-color);
  border-radius: 2rem;
  color: var(--text-color);
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.filter-pill:hover {
  border-color: var(--primary-color);
  background: var(--hover-color);
}

.filter-pill.active {
  background: var(--primary-color);
  border-color: var(--primary-color);
  color: white;
}

.filter-pill.reset {
  margin-left: auto;
  color: var(--primary-color);
}

/* Detailed filters */
.detailed-filters {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid var(--border-color);
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.filter-group label {
  font-weight: 500;
  font-size: 0.875rem;
  color: rgba(250, 249, 246, 0.8);
}

/* Experience slider */
.experience-slider {
  margin: 0.5rem 0;
}

.experience-presets {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.preset-btn {
  padding: 0.3rem 0.6rem;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid var(--border-color);
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  font-size: 0.75rem;
  font-weight: 900;
  background-color: rgb(212,47,61);
  transition: all 0.2s ease;
  border-radius: 4px;
  min-width: 3rem;
  text-align: center;
}

.preset-btn:hover {
  background: var(--hover-color);
  color: white;
}

.preset-btn.active {
  background:rgba(212,47,61,0.2);
  color: white;
  border-color: var(--primary-color);
}

/* Selected skills chips */
.selected-skills {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.skill-chip {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0.75rem;
  background:  rgba(212,47,61,0.2);
  border: 1px solid rgba(234, 94, 19, 0.3);
  border-radius: 1rem;
  font-size: 0.875rem;
  color: var(--text-color);
}

.chip-remove {
  background: none;
  border: none;
  color: var(--primary-color);
  cursor: pointer;
  padding: 0;
  font-size: 0.75rem;
  opacity: 0.7;
}

.chip-remove:hover {
  opacity: 1;
}

/* AI options */
.ai-options {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  font-size: 0.875rem;
}

.checkbox-label input[type="checkbox"] {
  width: 1rem;
  height: 1rem;
  cursor: pointer;
}

.rag-fields,
.semantic-search-basic {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-left: 1.5rem;
}

.semantic-input {
  resize: vertical;
  font-family: 'Courier New', Courier, monospace;
  min-height: 80px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid var(--border-color);
  color: var(--text-color);
  padding: 0.75rem;
  border-radius: 0.5rem;
}

.vector-fields-container {
  margin-top: 0.5rem;
}

.vector-field-checkboxes {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 0.5rem;
}

.vector-field-checkbox {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.semantic-actions {
  display: flex;
  gap: 0.75rem;
  margin-top: 0.5rem;
}

.semantic-button,
.semantic-reset {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.semantic-button {
  background: var(--primary-color);
  color: white;
}

.semantic-button:hover:not(:disabled) {
  background: #b74211;
}

.semantic-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.semantic-reset {
  background: rgba(250, 249, 246, 0.1);
  color: var(--text-color);
}

.semantic-reset:hover {
  background: rgba(250, 249, 246, 0.2);
}

/* Results summary */
.results-summary {
  text-align: center;
  margin-top: 1.5rem;
  font-size: 0.875rem;
  color: rgba(250, 249, 246, 0.7);
}
.simple-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.simple-pagination-btn {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: 1px solid var(--border-color);
  color: var(--text-color);
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.7rem;
}

.simple-pagination-btn:hover:not(:disabled) {
  background: var(--hover-color);
}

.simple-pagination-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.simple-page-indicator {
  font-size: 0.75rem;
  color: rgba(250, 249, 246, 0.7);
}
/* Loading overlay */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(38, 38, 36, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loading-content {
  text-align: center;
}

.loading-spinner {
  width: 3rem;
  height: 3rem;
  border: 3px solid var(--surface-color);
  border-top-color: var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1rem;
}

.loading-text {
  color: var(--text-color);
  font-size: 1.125rem;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Transitions */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-1rem);
}
 

/* Responsive */
@media (max-width: 768px) {
  .search-bar {
    border-radius: 1rem;
  }
  
  .quick-filters {
    justify-content: center;
  }
  
  .filter-pill.reset {
    margin-left: 0;
    width: 100%;
    justify-content: center;
    margin-top: 0.5rem;
  }
  
  .experience-presets {
    justify-content: space-between;
  }
  
  .preset-btn {
    flex: 1;
    min-width: auto;
  }
}
 
/* Contact filters */
.contact-filters {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0.75rem;
  margin-top: 0.5rem;
}

.contact-input-group {
  position: relative;
  display: flex;
  align-items: center;
}

.contact-input {
  flex: 1;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid var(--border-color);
  color: var(--text-color);
  padding: 0.75rem;
  border-radius: 0.5rem;
  font-size: 0.875rem;
}

.contact-input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(234, 94, 19, 0.1);
}

.contact-input::placeholder {
  color: rgba(250, 249, 246, 0.5);
}

.clear-contact {
  position: absolute;
  right: 0.75rem;
  color: var(--primary-color);
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.clear-contact:hover {
  opacity: 1;
}

/* Contact chips */
.selected-contacts {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.75rem;
}

.contact-chip {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0.75rem;
  background: rgba(212, 47, 61, 0.2);
  border: 1px solid rgba(234, 94, 19, 0.3);
  border-radius: 1rem;
  font-size: 0.875rem;
  color: var(--text-color);
} 


 /* Base multiselect styling */
:deep(.p-multiselect) {
  background: var(--surface-color) !important;
  border: 1px solid var(--border-color) !important;
  color: var(--text-color) !important;
  border-radius: 0.5rem;
}

:deep(.p-multiselect-label) {
  color: var(--text-color) !important;
}

:deep(.p-multiselect-placeholder) {
  color: var(--text-color) !important;
  opacity: 0.6;
}

:deep(.p-multiselect-trigger) {
  color: var(--text-color) !important;
}

/* Light theme only */
:root[data-theme="light"] :deep(.p-multiselect-panel) {
  background: #ede9e4 !important;
  border: 1px solid rgba(42, 42, 40, 0.08) !important;
  border-radius: 0.5rem !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
  z-index: 9999 !important;
}
:root[data-theme="dark"] .teams-logo {
  filter: brightness(0) invert(1); /* makes it white */
}
:root[data-theme="light"] :deep(.p-multiselect-item) {
  color: #2a2a28 !important;
  background: transparent !important;
}

:root[data-theme="light"] :deep(.p-multiselect-item:hover) {
  background: rgba(212, 47, 61, 0.1) !important;
  color: #2a2a28 !important;
}

:root[data-theme="light"] :deep(.p-multiselect-filter) {
  background: #ede9e4 !important;
  border: 1px solid rgba(42, 42, 40, 0.08) !important;
  color: #2a2a28 !important;
}

/* Dark theme only */
:root[data-theme="dark"] :deep(.p-multiselect-panel) {
  background: #2e2e2a !important;
  border: 1px solid rgba(250, 249, 246, 0.1) !important;
  border-radius: 0.5rem !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3) !important;
  z-index: 9999 !important;
}

:root[data-theme="dark"] :deep(.p-multiselect-item) {
  color: #FAF9F6 !important;
  background: transparent !important;
}

:root[data-theme="dark"] :deep(.p-multiselect-item:hover) {
  background: rgba(212, 47, 61, 0.1) !important;
  color: #FAF9F6 !important;
}

:root[data-theme="dark"] :deep(.p-multiselect-filter) {
  background: #2e2e2a !important;
  border: 1px solid rgba(250, 249, 246, 0.1) !important;
  color: #FAF9F6 !important;
}



.sort-options {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.sort-option-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1rem;
  background: var(--surface-color);
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  color: var(--text-color);
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
  flex: 1;
  min-width: 140px;
  justify-content: center;
}

.sort-option-btn:hover {
  border-color: var(--primary-color);
  background: var(--hover-color);
}

.sort-option-btn.active {
  background: var(--primary-color);
  border-color: var(--primary-color);
  color: white;
}

.sort-option-btn i {
  font-size: 0.875rem;
}
/* Boolean syntax help section */
.boolean-help-section {
  background: rgba(234, 94, 19, 0.05);
  border: 1px solid rgba(234, 94, 19, 0.2);
  border-radius: 0.5rem;
  padding: 1rem;
}

.boolean-syntax-card {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.syntax-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--primary-color);
  font-weight: 600;
  font-size: 0.875rem;
}

.syntax-header i {
  font-size: 1rem;
}

.syntax-examples {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 0.75rem;
}

.syntax-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.5rem;
  background: rgba(255, 255, 255, 0.02);
  border-radius: 0.25rem;
  border-left: 2px solid var(--primary-color);
}

.syntax-item code {
  font-family: 'Courier New', monospace;
  color: var(--primary-color);
  font-size: 0.875rem;
  font-weight: 600;
  background: rgba(234, 94, 19, 0.1);
  padding: 0.2rem 0.4rem;
  border-radius: 0.25rem;
  display: inline-block;
}

.syntax-item span {
  font-size: 0.75rem;
  color: rgba(250, 249, 246, 0.7);
}

.syntax-note {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem;
  background: rgba(234, 94, 19, 0.1);
  border-radius: 0.25rem;
  margin-top: 0.5rem;
}

.syntax-note i {
  color: var(--primary-color);
  font-size: 1rem;
}

.syntax-note small {
  color: rgba(250, 249, 246, 0.8);
  font-size: 0.75rem;
  line-height: 1.4;
}

/* Boolean pill visual feedback when active */
.filter-pill.active[data-filter="boolean"] {
  background: linear-gradient(135deg, var(--primary-color), #d42f3d);
  border-color: var(--primary-color);
  box-shadow: 0 2px 8px rgba(234, 94, 19, 0.3);
}
.boolean-badge {
  position: absolute;
  top: 0.5rem;
  right: 3rem;
  padding: 0.25rem 0.5rem;
  background: var(--primary-color);
  color: white;
  font-size: 0.65rem;
  font-weight: 600;
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  z-index: 1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.boolean-badge i {
  font-size: 0.7rem;
}

/* Fade transition for badge */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}


/* HOTLISTs */


.hot-list-banner {
  background: linear-gradient(135deg, #fff3cd 0%, #ffe4a0 100%);
  border: 1px solid #ffc107;
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
}

.banner-content {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: #856404;
}

.banner-content i.fa-fire {
  color: #ff6b6b;
  font-size: 1.25rem;
}

.banner-content strong {
  color: #ff6b6b;
}

.clear-btn {
  margin-left: auto;
  padding: 0.25rem 0.5rem;
  background: transparent;
  border: none;
  color: #856404;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.clear-btn:hover {
  opacity: 1;
}
/* NL Search Toggle Button */
.nl-toggle-button {
  background: transparent;
  border: 1px solid var(--border-color);
  color: var(--text-color);
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nl-toggle-button:hover {
  border-color: var(--primary-color);
  color: var(--primary-color);
}

.nl-toggle-button.active {
  background: var(--primary-color);
  border-color: var(--primary-color);
  color: white;
  box-shadow: 0 2px 8px rgba(234, 94, 19, 0.3);
}

.nl-toggle-button i {
  font-size: 1rem;
}

.nl-toggle-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Update search bar to accommodate new button */
.search-actions {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  position: relative;  /* NEW: positioning context for toast */

}
/* AI Warning Toast - Minimal & Snarky */
/* AI Warning Toast - Next to search bar */

/* AI Warning Toast - Inside search bar */
.ai-warning-toast {
  position: absolute;
  right: 100%;  /* Position to the left of the buttons */
  margin-right: 0.75rem;  /* Small gap from buttons */
  top: 50%;
  transform: translateY(-50%);
  background: linear-gradient(135deg, #FFA726 0%, #FF7043 100%);
  color: white;
  padding: 0.5rem 0.875rem;
  border-radius: 0.375rem;
  box-shadow: 0 2px 8px rgba(255, 152, 0, 0.3);
  display: flex;
  align-items: center;
  gap: 0.375rem;
  font-size: 0.8rem;
  font-weight: 500;
  z-index: 10;
  white-space: nowrap;
  pointer-events: none;
}

.ai-warning-toast i {
  font-size: 0.875rem;
  animation: pulse-glow 2s infinite;
}

@keyframes pulse-glow {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

/* Slide animation from the right */
.fade-slide-enter-active {
  animation: slide-in-right 0.3s ease-out;
}

.fade-slide-leave-active {
  animation: slide-out-right 0.3s ease-in;
}

@keyframes slide-in-right {
  from {
    opacity: 0;
    transform: translateY(-50%) translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateY(-50%) translateX(0);
  }
}

@keyframes slide-out-right {
  from {
    opacity: 1;
    transform: translateY(-50%) translateX(0);
  }
  to {
    opacity: 0;
    transform: translateY(-50%) translateX(20px);
  }
}

/* Dark mode */
:root[data-theme="dark"] .ai-warning-toast {
  background: linear-gradient(135deg, #FF8A65 0%, #FF5722 100%);
  box-shadow: 0 2px 8px rgba(255, 87, 34, 0.4);
}
.view-filter-bar {
  display: flex;
  gap: 4px;
  padding: 4px 0;
  margin-top: 6px;
}

.view-filter-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border: 1px solid rgba(250,249,246,0.08);
  border-radius: 6px;
  background: transparent;
  color: rgba(250,249,246,0.4);
  font-size: 0.7rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.view-filter-btn:hover {
  background: rgba(250,249,246,0.04);
  color: rgba(250,249,246,0.7);
}

.view-filter-btn.active {
  background: rgba(59,130,246,0.12);
  border-color: rgba(59,130,246,0.25);
  color: #93c5fd;
}

.view-filter-btn i { font-size: 0.6rem; }


.add-all-bar { position: relative; display: inline-flex; margin-top: 6px; }
.add-all-btn { padding: 5px 12px; border-radius: 6px; border: 1px solid rgba(59,130,246,0.2); background: rgba(59,130,246,0.06); color: #93c5fd; font-size: 0.7rem; font-weight: 600; cursor: pointer; display: flex; align-items: center; gap: 5px; transition: all 0.15s; }
.add-all-btn:hover { background: rgba(59,130,246,0.12); }
.add-all-picker { position: absolute; top: 100%; left: 0; margin-top: 4px; background: var(--background-color); border: 1px solid var(--border-color); border-radius: 8px; min-width: 200px; max-height: 260px; overflow-y: auto; padding: 4px 0; box-shadow: 0 8px 20px rgba(0,0,0,0.3); z-index: 100; }
.aap-loading { padding: 10px; text-align: center; color: #93c5fd; font-size: 0.65rem; }
.aap-option { display: flex; align-items: center; gap: 6px; width: 100%; padding: 7px 12px; border: none; background: none; color: var(--text-color); font-size: 0.7rem; font-weight: 600; cursor: pointer; text-align: left; }
.aap-option:hover { background: var(--surface-color); }
.aap-dot { width: 7px; height: 7px; border-radius: 2px; flex-shrink: 0; }
</style>